export const CollectionStateUpdate = {
  NOT_YET_COLLECTED: 'notYetCollected',
  COLLECTED: 'collected',
  NOT_COLLECTED: 'notCollected',
} as const;

export type CollectionStateUpdateType =
  (typeof CollectionStateUpdate)[keyof typeof CollectionStateUpdate];

export type CollectionStateUpdateItem = {
  donationId: string;
  orderId: string;
  status: CollectionStateUpdateType;
};
